var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4298 20.2816L16.3302 10.7167L20.4127 6.6342C22.1624 4.88454 22.7456 2.55165 22.1624 1.38521C20.996 0.801991 18.6631 1.38521 16.9134 3.13487L12.8309 7.21742L3.26604 5.11782C2.68282 5.00118 2.21624 5.23447 1.98295 5.70105L1.63302 6.28427C1.39973 6.86749 1.51638 7.45071 1.98295 7.80064L8.16509 11.8832L5.83221 15.3825H2.33288L1.16644 16.549L4.66577 18.8818L6.99865 22.3812L8.16509 21.2147V17.7154L11.6644 15.3825L15.747 21.5647C16.0969 22.0312 16.6801 22.1479 17.2633 21.9146L17.8466 21.6813C18.3131 21.3314 18.5464 20.8648 18.4298 20.2816Z",
    stroke: "#6A7282",
    strokeWidth: 2.33288,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight1);
export default __webpack_public_path__ + "static/media/flight1.28f3ede26388156b07ec33e48ae63b7b.svg";
export { ForwardRef as ReactComponent };